import React, { Component } from 'react';
//import { FormControl, FormGroup, Button } from 'react-bootstrap';

import mixpanel from "mixpanel-browser";
import axios from "axios";
import { Button } from "react-bootstrap";
import { Grid, Row, Col } from "react-bootstrap";

import '../content/content.css';


class ApiCallDashboard extends Component {

	constructor() {
		super();		
		this.state = { apiCallCount: 0 };
		this.mixpanel = mixpanel;
        this.getApiCallCount = this.getApiCallCount.bind(this);
	}

	componentDidMount() {
		this.getApiCallCount();
	}

    getApiCallCount() {
        let that = this;
        axios
            .get("/api/api-call-count", {
                params: { }
            })
            .then(function(response) {              
                that.setState({ loading: false });
                that.setState({ apiCallCount: response.data.count });
                console.log(response);

                that.mixpanel.track("Get Api Call Count", {
                    success: true,                    
                    isLoggedIn: that.state.isLoggedIn
                });
            })
            .catch(function(error) {                
                that.mixpanel.track("Api Call Count failed", {
                    success: false,
                    error: error,
                    isLoggedIn: that.state.isLoggedIn 
                });                
                that.setState({error: true, loading: false, apiCallCount: {}});
            });
    }

    render() {
    	return (
            <Row>
                <Col md={12} className="text-center">
                    <h2>{this.state.apiCallCount}</h2>
                </Col>
            </Row>
    	)
    }
}

export default ApiCallDashboard;



// WEBPACK FOOTER //
// ./src/api/ApiCallDashboard.js